<template>
  <b-modal v-model="isShown" centered hide-header hide-footer>
    <div class="be-room-card__qty-modal" v-if="rate">
      <div class="be-room-card__qty-modal-head">
        <p class="be-room-card__qty-modal-title">{{ $t('hotel.unit-type.' + type.type + '.more-unit') }}</p>
        <button type="button" class="be-room-card__qty-modal-close" @click="$emit('close')">
          <X :size="18" />
        </button>
      </div>
      <p class="be-room-card__qty-modal-left">{{ roomLeftText }}</p>
      <div class="be-room-card__stepper">
        <button
          type="button"
          class="be-room-card__stepper-btn"
          :disabled="qty <= 1"
          @click="qty--">
          <Minus :size="16" />
        </button>
        <input
          class="be-room-card__stepper-input"
          :value="qty"
          @keypress="inputCustomOnly"
          @change="setQty($event)" />
        <button
          type="button"
          class="be-room-card__stepper-btn"
          :disabled="qty >= maxQty"
          @click="qty++">
          <Plus :size="16" />
        </button>
      </div>
      <button type="button" class="be-room-card__qty-modal-book" @click="submit('book')">{{ $t('hotel.book-now') }}</button>
      <button type="button" class="be-room-card__qty-modal-cart" @click="submit('cart')">Add to Cart</button>
    </div>
  </b-modal>
</template>

<script>
  import { Minus, Plus, X } from 'lucide-vue';
  import { inputCustomOnly } from '@/utils/index.js';

  export default {
    name: 'RoomCardQtyModal',
    components: {
      Minus,
      Plus,
      X
    },
    props: {
      rate: {
        type: Object,
        default: null
      },
      type: {
        type: Object,
        default: () => ({})
      },
      maxQty: {
        type: Number,
        default: 1
      },
      initialQty: {
        type: Number,
        default: 1
      },
      roomLeftText: {
        type: String,
        default: ''
      }
    },
    data(){
      return {
        qty: 1
      }
    },
    computed: {
      isShown: {
        get(){
          return this.rate !== null;
        },
        set(isShown){
          if(!isShown) this.$emit('close');
        }
      }
    },
    watch: {
      rate(openedRate){
        if(openedRate !== null) this.qty = this.initialQty;
      }
    },
    methods: {
      inputCustomOnly($event){
        inputCustomOnly('number', $event)
      },
      setQty(event){
        const parsedQty = parseInt(event.target.value) || 1;
        this.qty = Math.min(Math.max(parsedQty, 1), this.maxQty);
        // sync the DOM in case clamping resolves to the same reactive value
        event.target.value = this.qty;
      },
      submit(action){
        this.$emit('submit', { action, qty: this.qty });
      }
    }
  }
</script>

<style scoped>
/* modal is portaled to <body>, outside .be-landing/.be-room-card — restate the font family */
.be-room-card__qty-modal {
  font-family: var(--be-v3-content-font, BeV3Sans), sans-serif;
}
.be-room-card__qty-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  margin-bottom: 20px;
  border-bottom: 1px solid #d5d9e0;
}
/* modal is portaled to <body>, outside .be-room-card — repeat the ramp values literally */
.be-room-card__qty-modal-title {
  margin: 0;
  font-size: 1.125rem;
  line-height: 1.3;
  font-weight: 600;
  color: #1a1a2e;
}
.be-room-card__qty-modal-close {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #fff;
  border: 1px solid #d5d9e0;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  cursor: pointer;
}
.be-room-card__qty-modal-left {
  margin-bottom: 16px;
  font-size: 0.875rem;
  font-weight: 400;
  color: #d0342c;
  text-align: center;
}
.be-room-card__stepper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border: 1px solid #d5d9e0;
  border-radius: 14px;
  margin-bottom: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.be-room-card__stepper-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #fff;
  border: 1px solid #c2c7d0;
  border-radius: 50%;
  color: #777;
  cursor: pointer;
}
.be-room-card__stepper-btn:disabled {
  opacity: 0.4;
  cursor: default;
}
.be-room-card__stepper-input {
  width: 80px;
  border: none;
  outline: none;
  font-size: 1.25rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  color: #1a1a2e;
  text-align: center;
}
.be-room-card__qty-modal-book,
.be-room-card__qty-modal-cart {
  display: block;
  width: 100%;
  padding: 12px 14px;
  border-radius: var(--be-v3-button-radius, 999px);
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
}
.be-room-card__qty-modal-book {
  background: var(--merchant-button-color, var(--merchant-primary-color, #79a33a));
  color: #fff;
  border: none;
  margin-bottom: 10px;
}
.be-room-card__qty-modal-cart {
  background: #fff;
  color: var(--merchant-primary-color, #79a33a);
  border: 1px solid var(--merchant-primary-color, #79a33a);
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/room-card/RoomCardQtyModal.vue